var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonateOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7935 8.11487C15.4566 7.4322 14.7613 7 14 7C13.2387 7 12.5434 7.4322 12.2065 8.11487L11.2024 10.1494L8.95712 10.4757C8.20375 10.5852 7.57785 11.1129 7.3426 11.8369C7.10735 12.5609 7.30355 13.3557 7.84869 13.8871L9.4734 15.4708L9.08986 17.707C8.96117 18.4573 9.26961 19.2156 9.8855 19.6631C10.5014 20.1106 11.3179 20.1696 11.9918 19.8153L14 18.7596L16.0082 19.8153C16.6821 20.1696 17.4986 20.1106 18.1145 19.6631C18.7304 19.2156 19.0388 18.4573 18.9101 17.707L18.5266 15.4708L20.1513 13.8871C20.6965 13.3557 20.8926 12.5609 20.6574 11.8369C20.4221 11.1129 19.7963 10.5852 19.0429 10.4757L16.7976 10.1494L15.7935 8.11487ZM12.5305 11.9775L14 9L15.4695 11.9775L18.7553 12.4549L16.3776 14.7725L16.9389 18.0451L14 16.5L11.0611 18.0451L11.6224 14.7725L9.24472 12.4549L12.5305 11.9775Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2ZM4 14C4 8.47715 8.47715 4 14 4C19.5228 4 24 8.47715 24 14C24 19.5228 19.5228 24 14 24C8.47715 24 4 19.5228 4 14Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateOutline);
export default __webpack_public_path__ + "static/media/donate_outline.e073ecab03812d4c2fcd4ead96daffee.svg";
export { ForwardRef as ReactComponent };